export const MONTHS = {
  JANUARY: "01",
  FEBRUARY: "02",
  MARCH: "03",
  APRIL: "04",
  MAY: "05",
  JUNE: "06",
  JULY: "07",
  AUGUST: "08",
  SEPTEMBER: "09",
  OCTOBER: "10",
  NOVEMBER: "11",
  DECEMBER: "12",
};

export const monthsOptions = [
  { value: MONTHS.JANUARY, label: "January" },
  { value: MONTHS.FEBRUARY, label: "February" },
  { value: MONTHS.MARCH, label: "March" },
  { value: MONTHS.APRIL, label: "April" },
  { value: MONTHS.MAY, label: "May" },
  { value: MONTHS.JUNE, label: "June" },
  { value: MONTHS.JULY, label: "July" },
  { value: MONTHS.AUGUST, label: "August" },
  { value: MONTHS.SEPTEMBER, label: "September" },
  { value: MONTHS.OCTOBER, label: "October" },
  { value: MONTHS.NOVEMBER, label: "November" },
  { value: MONTHS.DECEMBER, label: "December" },
];

export const monthsValues = Object.values(MONTHS) as [string, ...string[]];
